/* eslint-disable no-multi-str */
export default [
  {
    name: "18 января 1654 г. - Воссоединение Малороссии с Россией",
    shortDesc:
      "Малороссия была принята в состав Российского государства в 1654 году. Воссоединение осуществлялось на правах автономии: Россия признала выборность гетмана, местный суд и другие органы власти, которые сложились еще во времена зависимости малороссийских земель от Речи Посполитой. Также были подтверждены сословные права малоросского дворянства. Малороссия получила право устанавливать дипломатические отношения со всеми странами, кроме Турции и Польши. Для России Переяславское соглашение привело к приобретению части земель Западной Руси, в том числе древнего Киева, который московские великие князья и цари на протяжении веков считали своей вотчиной. Это событие стало очередным этапом «собирания земли русской», которое было отражено в их претензионном титуле государей всея Руси. Для Речи Посполитой это соглашение стало началом процессов распада и расчленения, приведших в итоге к полной потере независимости в 1795 г.",
    img: "/assets/imgs/kalendar/image-000.jpg",
    url: "vossoedinenie-malorossiy",
    fullDesc: "",
    quizes: [
      {
        name: "Какое событие ознаменовало воссоединение Малороссии с Россией?",
        variations: [
          {
            name: "Перяславская рада",
            isCorrect: true,
          },
          { name: "Заключение Белзкого договора" },
          { name: "Основание Киевской Руси" },
          { name: "Внедрение крестьянской реформы" },
        ],
      },
    ],
  },
  // {
  //   name: "18 января 1944 г. - прорыв блокады Ленинграда",
  //   shortDesc:
  //     "27 января 1944 года блокада Ленинграда была полностью снята, а враг начал отступать под ударами победоносной Красной армии. Этот день навсегда останется символом несгибаемой воли, стойкости и мужества многонационального народа России. Единство советского народа, его верность отечеству и любовь к родному городу позволили выстоять в самых суровых условиях и дать достойный отпор врагу. Немецко-фашистские оккупанты и их союзники смогли изолировать ленинградцев, однако защитники города до конца блокадных дней сохраняли единство со своими согражданами по ту сторону фронта. Ни голод, ни холод, ни смерть не сломили защитников города-героя Ленинграда. В память о блокаде открыты музеи и памятники, среди них можно выделить музей «Дорога жизни», музей-заповедник «Прорыв блокады Ленинграда», мемориал «Синявские высоты» и мемориал «Разорванное кольцо». Каждый экспонат и мемориал хранит в себе память, стойкость и мужество ленинградцев, не позволяя забыть об их подвиге. ",
  //   img: "/assets/imgs/kalendar/image-001.jpg",
  //   url: "proryv-blokady-leningrada",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Какое событие связано с прорывом блокады Ленинграда во время Великой Отечественной войны?",
  //       variations: [
  //         {
  //           name: "Операция 'Янтарный гром'",
  //           isCorrect: true,
  //         },
  //         { name: "Подписание Пакта Молотова-Риббентропа" },
  //         { name: "Основание Варшавского пакта" },
  //         { name: "Освобождение Берлина" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "25 января 1775 г. - День российского студенчества",
    shortDesc:
      "День российского студенчества, отмечаемый 25 января, непосредственно связан с созданием МГУ. Московский университет учрежден указом императрицы Елизаветы Петровны по инициативе М.В. Ломоносова и при поддержке графа И.И. Шувалова. В настоящее время в университете обучается более 50 тыс. студентов, аспирантов, слушателей, повышающих квалификацию и других обучающихся из всех регионов России, а также иностранцы. Филиалы Московского государственного университета имени М.В. Ломоносова созданы в Астане, Баку, Ташкенте, Душанбе, Севастополе и других городах. Изначально университет располагался на месте Государственного исторического музея на Красной площади. В 1782 году для расширения своих владений университет выкупил двор с каменными и деревянными постройками княгини А.М. Волконской в приходе церкви Дионисия Ареопагита на Никитской улице. При Екатерине II в 1793 году университет переехал в специально построенное здание на противоположной стороне Моховой. В данный момент МГУ располагает обширным комплексом зданий, а Главное здание располагается на Воробьевых горах и было открыто 1 сентября 1953 года.",
    img: "/assets/imgs/kalendar/image-002.jpg",
    url: "den-studenchestva",
    fullDesc: ".",
    quizes: [
      {
        name: "Какой праздник отмечается в России 25 января?",
        variations: [
          {
            name: "День российского студенчества ",
            isCorrect: true,
          },
          { name: "День знаний" },
          { name: "День освобождения студентов" },
          { name: "День науки" },
        ],
      },
    ],
  },
  {
    name: "27 января 1944 г. - День освобождения Ленинграда",
    shortDesc:
      "27 января 1944 года блокада Ленинграда была полностью снята, а враг начал отступать под ударами победоносной Красной армии. Этот день навсегда останется символом несгибаемой воли, стойкости и мужества многонационального народа России. Единство советского народа, его верность отечеству и любовь к родному городу позволили выстоять в самых суровых условиях и дать достойный отпор врагу. Немецко-фашистские оккупанты и их союзники смогли изолировать ленинградцев, однако защитники города до конца блокадных дней сохраняли единство со своими согражданами по ту сторону фронта. Ни голод, ни холод, ни смерть не сломили защитников города-героя Ленинграда. В память о блокаде открыты музеи и памятники, среди них можно выделить музей «Дорога жизни», музей-заповедник «Прорыв блокады Ленинграда», мемориал «Синявские высоты» и мемориал «Разорванное кольцо». Каждый экспонат и мемориал хранит в себе память, стойкость и мужество ленинградцев, не позволяя забыть об их подвиге. ",
    img: "/assets/imgs/kalendar/image-003.jpg",
    url: "den-osvobojdenia-leningrada",
    fullDesc: ".",
    quizes: [
      {
        name: "Сколько дней длилась блокада Ленинграда?",
        variations: [
          {
            name: "872 дня",
            isCorrect: true,
          },
          { name: "277 дней" },
          { name: "932 дня" },
          { name: "516 дней" },
        ],
      },
    ],
  },
  // {
  //   name: "28 января 1820 г. - Открытие Антарктиды",
  //   shortDesc:
  //     "Первой русской антарктической экспедицией под руководством Фадде Беллинсгаузена и Михаила Лазарева была открыта Антарктида.",
  //   img: "/assets/imgs/kalendar/image-004.jpg",
  //   url: "otrkritie-antarktidy",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Кто совершил открытие Антарктиды?",
  //       variations: [
  //         {
  //           name: "Фаддей Фаддеевич Беллинсгаузен",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "2 февраля 1943 г. - Сталинградская битва",
    shortDesc:
      "Сталинградская битва стала одним из важнейших и крупнейших генеральных сражений периода Второй мировой войны между силами Красной армии и немецко-фашистскими войсками, а также их союзниками. Немецкое военное командование планировало захватить большую излучину Дона, волгодонский перешеек и Сталинград (современный Волгоград), что позволило бы немцам отрезать Кавказ от СССР и захватить кавказские месторождения нефти, столь необходимой для ведения войны. Победа в Сталинградской битве стала «коренным переломом» не только в Великой Отечественной, но и во всей Второй мировой войне, навсегда войдя в мировую историю как победа советского многонационального народа над фашизмом. Являясь примером мужества, патриотизма и доблести наших предков, победа под Сталинградом напоминает нам о необходимости единства граждан России ради общего будущего. В память о великой победе советского народа в Сталинградской битве открыто множество памятников и мемориалов. Самые известные среди них – монумент «Родина-мать» на Мамаевом кургане, Музей-Панорама «Сталинградская битва» и мельница Гергардта. Ежегодно на Мамаевом кургане тысячи россиян празднуют День Победы, а с 2016 года на регулярной основе проходит патриотическая акция «Свет Великой Победы», являющаяся завершением остальных праздничных мероприятий 9 мая.",
    img: "/assets/imgs/kalendar/image-005.jpg",
    url: "stalingradskaya-bitva",
    fullDesc: ".",
    quizes: [
      {
        name: "В чем заключается важность Сталинградской битвы?",
        variations: [
          {
            name: "Эта битва стала началом коренного перелома в Великой Отечественной войне",
            isCorrect: true,
          },
          { name: "Эта битва завершила Великую Отечественную войну" },
          { name: "Это самое большое танковое сражение в истории" },
          { name: "Эта битва ничем не примечательна" },
        ],
      },
    ],
  },
  {
    name: "8 февраля 1724 г. - День российской науки",
    shortDesc:
      "Академия наук была создана по инициативе «сверху» в 1724 году. Академия являлась государственным учреждением, в задачи которого входило обеспечивать научно-технологическое развитие российского государства. В составе Академии были университет и гимназия. Первым президентом академии был назначен медик Лаврентий Блюментрост. Заботясь о соответствии деятельности Академии мировому уровню, Петр I пригласил в нее ведущих иностранных ученых. В числе первых были математики Николай и Даниил Бернулли, Христиан Гольдбах, физик Георг Бюльфингер, астроном и географ Жозеф Делиль, историк Г.Ф. Миллер. В 1727 году членом Академии стал Леонард Эйлер.",
    img: "/assets/imgs/kalendar/image-006.jpg",
    url: "den-nauki",
    fullDesc: ".",
    quizes: [
      {
        name: "К какому событию приурочен День российской науки?",
        variations: [
          {
            name: "К дню основания Петербургской академии наук",
            isCorrect: true,
          },
          { name: "К созданию славянской азбуки" },
          { name: "К дню рождения М. В. Ломоносова" },
          { name: "К дню основания Московского государственного университета" },
        ],
      },
    ],
  },
  // {
  //   name: "15 февраля 1989 г. - День памяти воинов-интенационалистов",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-007.jpg",
  //   url: "den-pamyati-internationalistov",
  //   fullDesc:
  //     "В этот день 1989 года закончился основной этап вывода советских войск из Афганистана.",
  //   quizes: [
  //     {
  //       name: "15 февраля 1989 года...",
  //       variations: [
  //         {
  //           name: "...завершен вывод советских войск из Афганистана",
  //           isCorrect: true,
  //         },
  //         { name: "...подписан Варшавский договор" },
  //         { name: "...прекратил существование СССР" },
  //         { name: "...произошла авария на Чернобыльской АЭС" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "23 февраля - День защитника отечества",
    shortDesc:
      "С 1922 года ежегодно в нашей стране отмечается День Советской Армии и Военно-Морского Флота, а после образования Российской Федерации – День защитника Отечества.  23 февраля стал не только днем воинской славы России, единства и сплоченности ее многонациональной армии, но и символом защиты нашего Отечества. В России установлено множество памятников защитникам Отечества, некоторых из них разделяют эпохи, но каждого объединяет любовь к родине и готовность защищать ее от врагов любой ценой.  Каждый год 23 февраля по всей стране проходят праздничные мероприятия. Проводят спортивные соревнования, в военных музеях представляют уникальные экскурсионные программы, на экранах показывают военные фильмы, а заканчивается день ярким салютом.",
    img: "/assets/imgs/kalendar/image-008.jpg",
    url: "den-zashitnika-otechestva",
    fullDesc: ".",
    quizes: [
      {
        name: "После великой отечественной войны и до 1949 года, 23 февраля отмечался как...",
        variations: [
          {
            name: "День Советской армии",
            isCorrect: true,
          },
          { name: "День Советской армии и флота" },
          { name: "День Красной армии" },
          { name: "День защитника Отечества" },
        ],
      },
    ],
  },
  // {
  //   name: "1 марта 1564 г. - Первая печатная книга",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-009.jpg",
  //   url: "pervaya-pechatnaya-kniga",
  //   fullDesc:
  //     "Первая в России книга 'Апостол' напечатана в 1563-1564 годах первопечатником Иваном Федоровым и Петром Мстиславцем.",
  //   quizes: [
  //     {
  //       name: "Назовите первую печатную книгу на Руси",
  //       variations: [
  //         {
  //           name: "Апостол",
  //           isCorrect: true,
  //         },
  //         { name: "Слово о полку Игореве" },
  //         { name: "Преступление и Наказание" },
  //         { name: "Летопись временных лет" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "18 марта 2014 г. - Крым навеки с Россией!",
    shortDesc:
      "В этот день подписан договор о принятии Республики Крым и г. Севастополя в состав России. Подписи под документом поставили Президент Российской Федерации Владимир Путин, Председатель Государственного Совета Республики Крым Владимир Константинов, Председатель Совета министров Республики Крым Сергей Аксенов и председатель координационного совета по организации Севастопольского городского управления по обеспечению жизнедеятельности Севастополя Алексей Чалый. Договор основывается на свободном и добровольном волеизъявлении народов Крыма на общекрымском референдуме, проведен- ном в Автономной Республике Крым и городе Севастополе 16 марта 2014 года, в ходе которого народы Крыма приняли решение о воссоединении с Россией. Напомним, на референдум были вынесены два вопроса: «1. Вы за воссоединение Крыма с Россией на правах субъекта РФ? 2. Вы за восстановление действия Конституции Республики Крым 1992 года и за статус Крыма как части Украины?».",
    img: "/assets/imgs/kalendar/image-010.jpg",
    url: "prisoedinenia-kryma",
    fullDesc: ".",
    quizes: [
      {
        name: "Какие субъекты вошли в состав Росии в 2014 году?",
        variations: [
          {
            name: "Республика Крым и город Севастополь",
            isCorrect: true,
          },
          {
            name: "Донецкая Народная Республика и Луганская Народная Республика",
          },
          { name: "Херсонская область и Запорожская область" },
          { name: "Абхазия и Южная Осетия" },
        ],
      },
    ],
  },
  {
    name: "4 апреля 1147 г. - Первое упоминание Москвы",
    shortDesc:
      "Москва, столица современной России, начала строиться князем Владимиро-Суздальским и великим князем Киевским Юрием Долгоруким (ок. 1090-1157), получившим свое прозвище за постоянное стремление расширить территории своих княжеств4. Москва была основана в период упадка Древнерусского государства — Русь распадалась на удельные княжества. Юрий Долгорукий активно строил новые города — так появились Переславль-Залесский, Юрьев-Польский, Дмитров. Место, где была основана Москва, располагалось на пересечении важных торговых путей. Через речные пути сообщения от Москвы можно было выйти как в Каспийское, так и в Азовское и Черное моря. Впоследствии Московское княжество выделилось из великого княжества Владимирского, а ее возвышение и стремительный рост начались в период ордынского нашествия на Русь.",
    img: "/assets/imgs/kalendar/image-011.jpg",
    url: "pervoye-upominanie-moskvy",
    fullDesc: ".",
    quizes: [
      {
        name: "В каком документе впервые упоминается Москва?",
        variations: [
          {
            name: "Ипатьевская летопись",
            isCorrect: true,
          },
          { name: "Остромирово Евангелие" },
          { name: "Повесть временных лет" },
          { name: "Лаврентьевская летопись" },
        ],
      },
    ],
  },
  {
    name: "5 апреля 1242 г. - Ледовое побоище",
    // eslint-disable-next-line no-multi-str
    shortDesc:
      "Битва на Чудском озере стала одной из крупнейших за всю историю немецко-рыцарской агрессии в северо-восточной Европе, а победа в ней русского воинства на долгие годы остановила притязания германцев на Русь. Кроме того, победа на Чудском озере в значительной степени сплотила русские княжества после многих десятилетий междоусобицы. Князь Александр Невский дал отпор иноземным захватчикам, объединив под своим командованием силы нескольких русских княжеств. 5 апреля 1242 года на Чудском озере русские воины сокрушили немецких рыцарей, проявив мужество, непоколебимую отвагу и тактическое превосходство. На месте Ледового побоища 11 сентября 2021 года в память о победоносном князе Александре Невском был открыт мемориальный комплекс в деревне Самолва в Псковской области. В установке памятника участвовало Российское военно-историческое общество при поддержке Министерства обороны, а на его открытии присутствовали президент России и патриарх Московский и всея Руси. Сегодня каждый желающий может побывать на месте исторически важной битвы, оценить масштаб и красоту монумента, а также насладиться природной красотой Чудского озера.",
    img: "/assets/imgs/kalendar/image-012.jpg",
    url: "ledovoe-poboishe",
    fullDesc: ".",
    quizes: [
      {
        name: "Где произошло Ледовое побоище?",
        variations: [
          {
            name: "Чудское озеро",
            isCorrect: true,
          },
          { name: "Байкал" },
          { name: "Озеро Верхнее" },
          { name: "Ладожское озеро" },
        ],
      },
    ],
  },
  {
    name: "12 апреля 1961 г. - День космонавтики",
    shortDesc:
      "12 апреля 1961 году советский космонавт Юрий Гагарин облетел Землю вокруг, став первым человеком, совершившим полет в космическое пространство. День космонавтики стал символом мужества наших космонавтов, гордостью отечественной науки и, без сомнения, огромной воли всего народа СССР. В честь отечественной космонавтики открыто множество музеев и памятников – памятник Юрию Гагарину и монумент «Покорителям ближней вселенной» в Москве, павильон «Космос» на ВДНХ, Музей истории космонавтики в Калуге и другие.  Ежегодно в День космонавтики по всей стране проходят различные тематические мероприятия, выставки, игры, спортивные соревнования и лекции. ",
    img: "/assets/imgs/kalendar/image-013.jpg",
    url: "den-kosmonavtiki",
    fullDesc: ".",
    quizes: [
      {
        name: "Как назывался космический корабль, на котором Ю. А. Гагарин впервые вышел в космос?",
        variations: [
          {
            name: "Восток-1",
            isCorrect: true,
          },
          { name: "Восток-2" },
          { name: "Аполлон-11" },
          { name: "Союз-1" },
        ],
      },
    ],
  },
  {
    name: "19 апреля 1783 г. - Екатерина II подписала манифест о присоединении Крыма и Кубани к России",
    shortDesc:
      "Вскоре после заключения Кючук-Кайнарджийского мира между Османской империей и Россией, в Крыму с помощью русских войск воцарился российский ставленник хан Шагин- Гирей. Прежний хан Девлет-Гирей поднял восстание, но вынужден был бежать в Турцию. А 8 апреля 1783 г. Екатерина II обнародовала указ о включении Крыма в состав России. Новоприсоединенные крымские владения называли Тавридой. В июне 1783 года в Карасубазаре, на вершине горы Ак-Кая князь Потемкин принял присягу на верность России крымской знати и представителей всех слоев крымского населения. Крымское ханство перестало существовать. Было организовано зем- ское правительство Крыма, в которое вошли татарские князья. Сохранился ордер Г.А. Потемкина командующему русски- ми войсками в Крыму генералу де Бальмену от 4 июля 1783 года: «Воля ее императорского величества есть, чтобы все войска, пре- бывающие в Крымском полуострове, обращались с жителями дружелюбно, не чиня отнюдь обид, чему подавать пример имеют начальники и полковые командиры».",
    img: "/assets/imgs/kalendar/image-014.jpg",
    url: "prisoyedinenie-kryma-i-kubani",
    fullDesc: "",
    quizes: [
      {
        name: "В составе какого государства находились Крым и Кубань до передачи их Российской Империи?",
        variations: [
          {
            name: "Османская империя",
            isCorrect: true,
          },
          { name: "Австрийская империя" },
          { name: "Монгольская империя" },
          { name: "Аварский каганат" },
        ],
      },
    ],
  },
  {
    name: "27 апреля 1906 г. - День российского парламентаризма",
    shortDesc:
      "27 апреля в России отмечается День российского парламентаризма, праздник относительно новый, он был установлен в 2012 году после внесения президентом России Владимиром Путиным изменений в федеральный закон «О днях воинской славы и памятных датах России» от 13 марта 1995 года. Первые официальные праздничные мероприятия прошли в 2013 году. Дата 27 апреля в качестве памятной выбрана не случайно, именно 27 апреля 1906 года по старому стилю, в России начала работу первая Государственная Дума, заложившая основы российского парламентаризма. День российского парламентаризма является символом преемственности государственных и парламентских традиций и призван привлечь внимание к деятельности Федерального собрания Российской Федерации, показать работу российских парламентариев.",
    img: "/assets/imgs/kalendar/image-015.jpg",
    url: "den-parlamentarisma",
    fullDesc: ".",
    quizes: [
      {
        name: "Сколько просуществовала дума I созыва?",
        variations: [
          {
            name: "72 дня",
            isCorrect: true,
          },
          { name: "31 день" },
          { name: "215 дней" },
          { name: "2 дня" },
        ],
      },
    ],
  },
  {
    name: "9 мая 1945 г. - День победы",
    shortDesc:
      "День Победы стал не только государственным праздником, но и символом доблести, отваги, мужества, патриотизма, а также единства советских граждан перед лицом сильного и жестокого врага, стремившегося уничтожить и поработить народы СССР. Многонациональный советский народ заплатил огромную цену, отстаивая право на жизнь и будущее людей всего мира.  В честь Победы советского народа в Великой Отечественной войне открыто множество памятников, ежегодно проходят праздничные мероприятия. Одними из главных памятных мест в России стали Мамаев курган в Волгограде, могила Неизвестного Солдата у стен Кремля, «Музей Победы» на Поклонной горе в Москве и музей-заповедник «Прохоровское поле» в Белгородской области. Ежегодное празднование Дня Победы стало важнейшей традицией народов России. Этот день не позволяет забыть о подвиге наших героических предков, объединяет российский народ, укрепляет его гражданскую идентичность и патриотизм.",
    img: "/assets/imgs/kalendar/image-016.jpg",
    url: "den-pobedy",
    fullDesc: ".",
    quizes: [
      {
        name: "Какое событие ознаменовало победу СССР в Великой Отечественной войне?",
        variations: [
          {
            name: "Акт о капитуляции Германии",
            isCorrect: true,
          },
          { name: "Парижский мирный договор" },
          { name: "Падение Рейхстага" },
          { name: "Акт о капитуляции Японии" },
        ],
      },
    ],
  },
  {
    name: "16 мая 1858 г. - Айгнуский договор",
    shortDesc:
      "В этот день был заключен договор, проложивший путь мирному присоединению Приамурья и Приморья к России. В 1858 г. с Китаем был заключен Айгунский договор, и к России присоединилось Приамурье. Военные походы открыли путь для мирной земледельческой колонизации Сибири, притока населения из европейской части страны. К времени прихода русских аборигенное население Сибири составляло около 230–240 тыс. чел. на 10 млн кв.км, а соотношение местного и пришлого населения на рубеже ХVI и ХVII вв. было один к 100, на рубеже ХVIII и ХIХ вв. — четыре к од- ному. В XVIII в. началось переселение значительных групп населения, инициированное правительством, что укрепляло позиции России в Сибири и постепенно способствовало интеграции последней в общее пространство страны. Первыми дорогу в Сибирь открыли старообрядцы, которых туда ссылала власть, но чаще они сами бежали от ее преследований. Религиозные поселенцы принесли с собой высокую аграрную культуру, начав культивировать ранее не известные в Сибири виды растений. Их отличали строгие нравы, безупречная трудовая этика, из их числа выросло немало династий сибирских купцов. ",
    img: "/assets/imgs/kalendar/image-017.jpg",
    url: "aigunskii-dogovor",
    fullDesc: ".",
    quizes: [
      {
        name: "Какие территории вошли в состав Российской империи согласно Айгунскому договору?",
        variations: [
          {
            name: "Приамурье и Приморье",
            isCorrect: true,
          },
          { name: "Крым и Кубань" },
          { name: "Северный и Южный Кавказ" },
          { name: "Карелия и Валаам" },
        ],
      },
    ],
  },
  // {
  //   name: "24 марта 2001 г. - День гимна Российской Федерации",
  //   shortDesc:
  //     "'Предками данная мудрость народная! Славься, страна! Мы гордимся тобой!'",
  //   img: "/assets/imgs/kalendar/image-018.jpg",
  //   url: "den-gimna",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Кто автор гимна Российской Федерации?",
  //       variations: [
  //         {
  //           name: "Александр Васильевич Александров",
  //           isCorrect: true,
  //         },
  //         { name: "Сергей Владимирович Михалков" },
  //         { name: "Владимир Семёнович Высоцкий" },
  //         { name: "Булат Шалвович Окуджава" },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   name: "24 мая 1863 г. - День славянской письменности",
  //   shortDesc:
  //     "В 1863 году Российский Святейший Синод определил, в связи с празднованием тысячелетия Моравской миссии святых Кирилла и Мефодия, установить ежегодное празднование в честь преподобных Мефодия и Кирилла.",
  //   img: "/assets/imgs/kalendar/image-019.jpg",
  //   url: "den-pismennosti",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Кем были Кирилл и Мефодий?",
  //       variations: [
  //         {
  //           name: "Создателями старославянской азбуки и церковнославянского языка",
  //           isCorrect: true,
  //         },
  //         { name: "Первыми книгопечатниками на Руси" },
  //         { name: "Основателями Петербугской академии наук" },
  //         { name: "Крестителями Руси" },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   name: "27 мая 1703 г. - День основания Сантк-Петербурга",
  //   shortDesc:
  //     "'Я предчувствую, что россияне когда-нибудь, а может быть, при жизни нашей пристыдят самые просвещенные народы успехами своими в науках, неутомимостью в трудах и величеством твёрдой и громкой славы' - Петр I.",
  //   img: "/assets/imgs/kalendar/image-020.jpg",
  //   url: "den-sankt-peterburga",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   name: "4 июня 1741 г. - Экспедиция Беринга на Аляску",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-021.jpg",
  //   url: "ekspedicia-na-alyasku",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   name: "6 июня 1799 г. - День русского языка",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-022.jpg",
  //   url: "den-yazyka",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "12 июня - День России",
    shortDesc:
      "12 июня 1990 г. Съезд народных депутатов РСФСР принял Декларацию о государственном суверенитете России . Помимо провозглашения суверенитета РСФСР и намерения создать новое демократическое правовое государство в составе обновленного Союза ССР, в декларации также утверждались: приоритет Конституции и законов РСФСР над законодательными акта- ми СССР, равные правовые возможности для новообразованных политических партий, общественных организаций и объединений, в том числе и неформальных, принцип разделения законодатель- ной, исполнительной и судебной властей, необходимость существенного расширения прав автономных республик, областей, округов, краев в составе РСФСР.",
    img: "/assets/imgs/kalendar/image-023.jpg",
    url: "den-rossii",
    fullDesc: ".",
    quizes: [
      {
        name: "К какому событию приурочен День России?",
        variations: [
          {
            name: "Принятия Декларации о государственном суверинитете России",
            isCorrect: true,
          },
          { name: "Прекращение существования СССР" },
          { name: "Первые выборы президента России" },
          { name: "Освобождение Москвы Мининым и Пожарским" },
        ],
      },
    ],
  },
  {
    name: "7 июля 1770 г. - Чесменское сражение",
    shortDesc:
      "Победа в Чесменском сражении показывает нам не только мощь русского оружия, но и силу нашего единства против общего врага. Матросы разного этнического происхождения сплотились, став великим морским воинством России, навсегда войдя в отечественную историю. Победа русского флота надолго подорвала силу турков и позволила блокировать пролив Дарданеллы. В конечном итоге победа в Чесменском сражении способствовала подписанию мирного договора между Россией и Османской империей в 1774 году (Кючук-Кайнарджийский мир), по которому Россия получила новые территории, в том числе город Азов. В честь победы русского флота в Чесменском сражении в 1778 году было воздвигнуто множество памятников, среди них – Церковь Рождества святого Иоанна Предтечи «Чесменская» в Санкт-Петербурге. Сегодня каждый имеет возможность посетить памятные места, посвященные победе русского флота.",
    img: "/assets/imgs/kalendar/image-024.jpg",
    url: "chesmenskoe-srajenie",
    fullDesc: ".",
    quizes: [
      {
        name: "Кто командовал флотом Российской империи во время Чесменского сражения?",
        variations: [
          {
            name: "Алексей Орлов",
            isCorrect: true,
          },
          { name: "Григорий Спиридонов" },
          { name: "Джон Эльфинстон" },
          { name: "Павел Нахимов" },
        ],
      },
    ],
  },
  {
    name: "8 июля 1228 г. - День семьи",
    shortDesc:
      "День семьи, любви и верности отмечается в России 8 июля в память о Петре и Февронии Муромских, считающихся покровителями семьи и брака. Довольно часто 8 июля выбирают для бракосочетаний, укрепляя добрую традицию и семейные ценности. В честь памятной даты в России открыто множество памятников, и первый из них в Муроме на исторической родине Петра и Февронии. Ежегодно в День семьи, любви и верности проходят многочисленные мероприятия. Также в День семьи, любви и верности награждают семейные пары, прожившие в браке более четверти века. ",
    img: "/assets/imgs/kalendar/image-025.jpg",
    url: "den-semyi",
    fullDesc: ".",
    quizes: [
      {
        name: "Кем были Петр и Феврония?",
        variations: [
          {
            name: "Князем и княгиней Мурома",
            isCorrect: true,
          },
          { name: "Создателями славянской письменности" },
          { name: "Участниками первой антарктической экспедиции" },
          { name: "Героями 'Cлова о полку Игореве'" },
        ],
      },
    ],
  },
  {
    name: "10 июля 1709 г. - Полтавское сражение",
    shortDesc:
      "Полтавская битва стала генеральным сражением Северной войны. После громких побед шведов над европейскими странами Россия вплоть до 1709 года в одиночку противостояла шведской экспансии.  Король Карл XII посчитав Полтавскую крепость «лёгкой добычей», потерпел полный разгром своих войск, после которого шведская армия не смогла оправиться вплоть до самого конца Семилетней войны. «Непобедимые доселе господа шведы хребет свой показали» - Пётр I.   Для России 11 июля стало не только днем большой победы, но днем объединения российского народа, укрепления нашей гражданской идентичности. Общая воля к победе объединила людей разной этнической и культурной принадлежности под одним знаменем.  В честь 100-летия победы в Полтавской битве в 1811 году был открыт памятник-колонна в центре Круглой площади в городе Полтава. ",
    img: "/assets/imgs/kalendar/image-026.jpg",
    url: "poltavskoe-srajenie",
    fullDesc: ".",
    quizes: [
      {
        name: "Во время какой войны произошло Полтавское сражение?",
        variations: [
          {
            name: "Северная война",
            isCorrect: true,
          },
          { name: "Отечественная война 1812 года" },
          { name: "Первая мировая война" },
          { name: "Великая Отечественная война" },
        ],
      },
    ],
  },
  {
    name: "28 июля 998 г. - День крещения Руси",
    shortDesc:
      "Самые ранние упоминания о проникновении христианства в восточнославянские земли восходят к первым векам нашей эры, когда в Малой Азии, на Балканском полуострове, в Северном Причерноморье и Крыму вели свои проповеди первые христианские апостолы и их ученики. Дохристианская (языческая) Русь отличалась большой веротерпимостью. Здесь свободно отправляли свои религиозные культы мусульмане и иудеи, христиане из Византии, из немецких, польских, чешских земель. Крещение князя Владимира и его приближенных было совершено в г. Корсуни (Херсонесе) — в центре византийских владений в Крыму. За этим последовало крещение жителей Киева и, посте- пенно, всего государства. Власть была заинтересована в единоверии, поскольку приверженность общим богам сближала людей, цементировала местные сообщества и позволяла подчинить общественную жизнь единым нравственным нормам. Принятие христианства как государствен- ной религии способствовало духовному объединению славянских и неславянских народов.",
    img: "/assets/imgs/kalendar/image-027.jpg",
    url: "den-kreshenia-rusi",
    fullDesc: ".",
    quizes: [
      {
        name: "Кто крестил Русь?",
        variations: [
          {
            name: "Владимир Святославович",
            isCorrect: true,
          },
          { name: "Юрий Долгорукий" },
          { name: "Александр Невский" },
          { name: "Игорь Рюрикович" },
        ],
      },
    ],
  },
  {
    name: "1 августа 1914 г. - День памяти русских воинов Первой мировой войны",
    shortDesc:
      "В июле 1914 г. Австро-Венгрия в ответ на убийство в Сараево сербским националистом эрцгерцога Франца Фердинанда предъявила Сербии ультиматум, а вскоре начала военные действия против нее. 30 июля Россия начала всеобщую мобилизацию, а 1 августа вступила в войну на стороне Сербии, что и стало началом первой мировой войны. Угроза войны первоначально привела к консолидации политических сил и различных слоев российского общества вокруг престола. 26 июля 1914 г. в Государственной Думе представители различных партий и национальностей империи всходили на трибуну и от имени своих избирателей заявляли о полной поддержке России в войне. Н. М. Фридман, представитель российских евреев, заявил, что, хотя «в исключительно тяжелых правовых условиях жили и живем мы, евреи, и тем не менее мы всегда чувствовали себя гражданами России и всегда были верными сынами своего отечества». Барон Г.Е. Фелькерзам провозгласил, что прибалтийские немцы, как и ранее, безусловно выполнят свой долг как верноподданные русского царя. Все попытки поднять восстание среди народов Кавказа успехом не увенчались. Из кавказских добровольцев была сформирована так называемая «Дикая дивизия» (Кавказская туземная конная дивизия, впоследствии — Кавказский туземный конный корпус), которая стала одним из самых боеспособных и известных боевых подразделений русской императорской армии. ",
    img: "/assets/imgs/kalendar/image-028.jpg",
    url: "den-pamyati-pervoi-mirovoi",
    fullDesc: ".",
    quizes: [
      {
        name: "В каком альянсе входила Россия в Первой мировой войне?",
        variations: [
          {
            name: "Антанта",
            isCorrect: true,
          },
          { name: "Центральные державы" },
          { name: "Союзные державы" },
          { name: "Тройственный союз" },
        ],
      },
    ],
  },
  // {
  //   name: "7 августа 1803 г. - Кругосветная экспедиция",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-029.jpg",
  //   url: "krugosvetnaya-expedicia",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "9 августа 1714 г. - Гангутское сражение",
    shortDesc:
      "Морское сражение Северной войны, состоявшееся 9 августа 1714 года у мыса Гангут в Балтийском море между русским и шведским флотом, положило начало великим победам России на море.  Решающее значение на исход сражения у мыса Гангут оказал император всероссийский Петр I, применив успешный тактический маневр против шведской эскадры. Именно усилиями Петра был создан русский флот, по сей день считающийся одним из сильнейших в мире.  В честь победы у мыса Гангут 27 июля 1870 года был открыт памятник недалеко от места исторической битвы в западной Финляндии. На торжественном открытии присутствовал император России Александр II. Победа русского флота доказала, что Россия одинаково сильна как на суше, так и на море.",
    img: "/assets/imgs/kalendar/image-030.jpg",
    url: "gangutskoye-srjenie",
    fullDesc: ".",
    quizes: [
      {
        name: "Что стало следствием победы русского флота в Гангутском сражении?",
        variations: [
          {
            name: "Укрепление позиций русского флота",
            isCorrect: true,
          },
          { name: "Переход под контроль России обширных территорий" },
          { name: "Победа России в Северной войне" },
          { name: "Получение Россией выхода к Балтийскому морю" },
        ],
      },
    ],
  },
  // {
  //   name: "22 августа 1991 г. - День государственного флага России",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-031.jpg",
  //   url: "den-flaga",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   name: "23 августа 1943 г. - Курская битва",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-032.jpg",
  //   url: "kurskaya-bitva",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "3 сентября 1945 г. - День окончания Второй мировой войны",
    shortDesc:
      "3 сентября 1945 года СССР одержал решительную победу над милитаристской Японией, окончательно завершив Вторую мировую войну. Памятный день об окончании самой страшной войны в истории человечества «символизирует переход от состояния войны к миру, поиску путей примирения и сотрудничества». Советский многонациональный народ понес колоссальные потери во Второй мировой войне, сражаясь за свое Отечество и за право на жизнь каждого человека на Земле. 3 сентября стало памятником мира и победы над фашизмом. В 1975 году в память о победе над милитаристской Японией и окончанием Второй мировой войны в городе Южно-Сахалинск был открыт музейно-мемориальный комплекс «Победа». В музее проходят различные мероприятия и тематические выставки, приуроченные к памятной дате.",
    img: "/assets/imgs/kalendar/image-033.jpg",
    url: "den-okonchania-vtoroi-mirovoi",
    fullDesc: ".",
    quizes: [
      {
        name: "Назовите дату окончания Второй мировой войны",
        variations: [
          {
            name: "3 сентября 1945 года",
            isCorrect: true,
          },
          { name: "9 мая 1945 года" },
          { name: "30 апреля 1945 года" },
          { name: "12 марта 1947 года" },
        ],
      },
    ],
  },
  // {
  //   name: "3 сентября 2004 г. - День солидарности в борьбе с терроризмом",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-034.jpg",
  //   url: "den-borbi-s-terrorismom",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "8 сентября 1812 г. - Бородинское сражение",
    shortDesc:
      "Отечественная война 1812 г - величайшее событие в истории России. В этой войне проявил- ся героизм всего народа, произошел подъем национального духа, а также значительно вырос и укрепился международный авторитет России. Кроме русских, в Отечественной войне 1812 г. в регулярной армии и народном ополчении участвовали представители многих народов Российской империи. В регулярной армии действовали татарские, калмыцкие, ногайские, крымско-татарские конные полки, в офицерском корпусе служили немецкие офицеры из Прибалтийских губерний, армянские и грузинские офицеры и генералы (грузин — 13 только генералов), включая генерала князя Багратиона. В войне принимало участие украинское и белорусское ополчения, чуваши, мордва, марийцы и представители других народов. После стремительного вступления «Великой армии» Наполеона русская армия выбрала тактику отступления вглубь России, ведя небольшие столкновения с противником. Итогом похода Наполеона на Россию стало Бородинское сражение, в котором была потеряна боеспособность войск французского императора, и, несмотря на взятие Москвы, французы были вынуждены отступать из России под ударами сильной русской армии.",
    img: "/assets/imgs/kalendar/image-035.jpg",
    url: "borodinskoe-srajenie",
    fullDesc: ".",
    quizes: [
      {
        name: "Кто командовал русской армией в Бородинском сражении?",
        variations: [
          {
            name: "М. И. Кутузов",
            isCorrect: true,
          },
          { name: "А. В. Суворов" },
          { name: "М. Б. Барклай де Толли" },
          { name: "П. И. Багратион" },
        ],
      },
    ],
  },
  {
    name: "8 сентября 1380 г. - Куликовская битва",
    shortDesc:
      "На Куликовом поле 8 сентября 1380 года состоялась битва между объединённым русским войском во главе с великим князем Дмитрием Ивановичем (Донским) и войском правителя Золотой Орды Мамая.  Воля к свободе, непоколебимая вера в победу и доблесть русских воинов привели к полному разгрому войска Мамая, положив начало к объединению и укреплению Руси после долгого периода междоусобных войн и тяжкого ордынского гнета. Дмитрий Донской помимо победы на Куликовом поле известен строительством белокаменного Московского Кремля, а также политическому укреплению Московского княжества, ставшего ядром будущего Российского государства. В память о великой победе над татаро-монгольскими войсками в середине 19-го века на месте битвы был построен мемориальный комплекс «Красный холм», состоящий из памятника-колонны Дмитрию Донскому и храма-памятника Сергию Радонежскому, возведенному уже в начале 20-го века. Мемориал является важнейшей достопримечательностью Тульской области, напоминая каждому посетителю об одной из самых значительных побед российского народа. ",
    img: "/assets/imgs/kalendar/image-036.jpg",
    url: "kulikovskaya-bitva",
    fullDesc: ".",
    quizes: [
      {
        name: "В чем заключается значение Куликовской битвы?",
        variations: [
          {
            name: "Это первая крупная победа русских княжеств над Золотой Ордой",
            isCorrect: true,
          },
          { name: "Эта битва привела к основанию Российской империи" },
          { name: "Эта битва закончилась развалом Золотой Орды" },
          { name: "В этой битве погиб Чингисхан" },
        ],
      },
    ],
  },
  {
    name: "11 сентября 1790 г. - Сражение у мыса Тендра",
    shortDesc:
      "Для успешного наступления русских войск в районе Дуная в ходе русско-турецкой войны 1787-1791 гг. было необходимо разбить крупный турецкий флот у мыса Тендра.  Решительность адмирала Федора Федоровича Ушакова, русский дух и воля к победе наших матросов привели к громкой победе над неприятелем. Сражение у мыса Тендра позволило русской армии разгромить османов на суше и принудить их к подписанию Ясского мира, по результатам которого они навсегда отказались от своих притязаний на земли Крымского ханства и черноморского побережья. Баланс сил на европейской арене изменился в пользу Российской империи, укрепившей свои геополитические позиции.  В память о великой победе русского флота над османами Александр Блинков в середине 20 века написал картину «Сражение у острова Тендра 28-29 августа 1790 года», находящуюся в Центральном военно-морском музее Санкт-Петербурга.",
    img: "/assets/imgs/kalendar/image-037.jpg",
    url: "srajenie-u-tendery",
    fullDesc: ".",
    quizes: [
      {
        name: "С флотом какого государства сражался русский флот у мыса Тендра?",
        variations: [
          {
            name: "Османская империя",
            isCorrect: true,
          },
          { name: "Шведская империя" },
          { name: "Австрийская империя" },
          { name: "Золотая Орда" },
        ],
      },
    ],
  },
  // {
  //   name: "21 сентября 998 г. - День русской государственности",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-038.jpg",
  //   url: "den-gosudarstvennosti",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "9 октября 1943 г. - Советские войска разгромили немцев в битве за Кавказ",
    shortDesc:
      "В битве за Кавказ солдаты и офицеры Красной армии проявили мужество и отвагу перед лицом сильного и грозного врага.  Битва за Кавказ имеет большое историческое значение. В случае победы врага произошел бы серьезный перевес в пользу врага, а советские войска лишились бы значительной доли топлива.  В память о подвиге советских воинов 2 ноября 1968 года в Карачаево-Черкессии был торжественно открыт музей-памятник защитникам перевалов Кавказа. Ежегодно в музее проводятся выставки «Гражданственности и патриотизма», мероприятия общественно гражданско-патриотического движения по сохранению личной памяти о Великой Отечественной войне «Свеча памяти», «Бессмертный полк», «Уроки мужества» и многие другие. Всего за годы существования музея его посетило свыше 5 миллионов человек.",
    img: "/assets/imgs/kalendar/image-039.jpg",
    url: "bitva-za-kavkaz",
    fullDesc: ".",
    quizes: [
      {
        name: "Назовите дату окончания битвы за Кавказ",
        variations: [
          {
            name: "9 октября 1943 года",
            isCorrect: true,
          },
          { name: "2 февраля 1943 года" },
          { name: "9 мая 1945 года" },
          { name: "15 августа 1945 года" },
        ],
      },
    ],
  },
  {
    name: "2 ноября 1721 г. - Провозглашение Российской Империи",
    shortDesc:
      "Российская империя была основана Петром I. Взойдя на трон, Петр продолжил войну с Крымом, взял крепость Азов. Дальнейшие действия Петра I были направлены на создание мощного флота. Он изучал кораблестроение, устройство и культуру многих стран и в результате захотел изменить Россию. Для этого были введены новые правила и реформы. Например, введено летоисчисление по юлианскому календарю. Следующим этапом правления Петра I стала война со Швецией. Заключив мир с Турцией, он захватил крепость Нотебург и крепость Ниеншанц. В мае 1703 года было начато строительство Санкт-Петербурга. В следующем году — взяты Нарва и Дерпт. В июне 1709 года в Полтавской битве Швеция была разгромлена. Вскоре после смерти Карла XII был заключен мир между Россией и Швецией. К России присоединились новые земли, был получен выход в Балтийское море. В 1721 году Петр I был провозглашен императором Всероссийским. За время его правления была присоединена Камчатка, завоеван берег Каспийского моря.",
    img: "/assets/imgs/kalendar/image-040.jpg",
    url: "provozglashenie-imperii",
    fullDesc: ".",
    quizes: [
      {
        name: "Кто стал первым императором Российской империи?",
        variations: [
          {
            name: "Петр I",
            isCorrect: true,
          },
          { name: "Александр I" },
          { name: "Павел I" },
          { name: "Николай I" },
        ],
      },
    ],
  },
  {
    name: "4 ноября 1612 г. - День народного единства",
    shortDesc:
      "День народного единства призван объединить многонациональный народ России, укрепить общероссийскую гражданскую идентичность и напомнить о славных событиях нашего общего прошлого. В сентябре 2004 года Межрелигиозный совет России выступил с предложением сделать 4 ноября Днем народного единства. Идея была поддержана Комитетом по труду и социальной политике при Государственной Думе и позднее она обрела статус думской инициативой.  Проект Дня народного единства был также поддержан многими политическими деятелями России, гражданами, а также Патриархом Московским и всея Руси Алексием II. В рамках Стратегии государственной национальной политики Российской Федерации на период до 2025 года День народного единства обретает еще большую значимость. Президент России отметил, что «сплоченность многонационального народа России и в годы испытаний, и при решении различных масштабных задач всегда была одним из ключевых моментов нашего существования». Символом народного единства стал памятник Минину и Пожарскому, установленный в самом сердце Москвы на Красной площади в 1818 году по проекту архитектора Ивана Мартоса. Минин и Пожарский сумели объединить российский народ и отстоять независимость России в условиях тяжелейшего смутного времени. ",
    img: "/assets/imgs/kalendar/image-041.jpg",
    url: "den-narodnogo-edinstva",
    fullDesc: ".",
    quizes: [
      {
        name: "К какому событию приурочен День народного единства?",
        variations: [
          {
            name: "Освобождение Москвы Мининым и Пожарским",
            isCorrect: true,
          },
          { name: "Победа русских княжеств в Куликовской битве" },
          { name: "Перяславская рада" },
          { name: "Основание Советского Союза Социалистических Республик" },
        ],
      },
    ],
  },
  {
    name: "7 ноября 1941 г. - Военный парад в Москве",
    shortDesc:
      "В условиях полной секретности и тяжелейшего положения на фронте, когда немецко-фашистские захватчики вплотную подошли к Москве, Иосиф Сталин принял решение о проведении военного парада на Красной площади. Парад был приурочен к празднованию 24-й годовщины Октябрьской революции, однако в столь сложный для страны период он обрел еще один важный смысл, оказав значительное влияние на весь советский народ и на ход Великой Отечественной войны в целом.  Проведение парада и личное присутствие И.В. Сталина укрепило моральный дух армии и воодушевило граждан СССР добровольно вступать в ряды Красной армии для защиты Отечества. Колонны красноармейцев и военной техники под вдохновляющие военные марши уходили с Красной площади на защиту столицы, отступать было некуда – за ними была Москва. Военный парад 7 ноября 1941 года символизирует стойкость и мужество, непоколебимость и отвагу многонационального советского народа перед лицом наступающего врага.",
    img: "/assets/imgs/kalendar/image-042.jpg",
    url: "voennyi-parad",
    fullDesc: ".",
    quizes: [
      {
        name: "В чем был главный смысл военного парада на Красной площади 7 ноября 1941 года",
        variations: [
          {
            name: "Поднятие морального духа Советской армии и воодушевление советских граждан",
            isCorrect: true,
          },
          { name: "Подготовка Советской армии к контрнаступлению" },
          { name: "Введение в заблуждение немецко-фашистких захватчиков" },
          { name: "Празднование годовщины Октябрьской революции" },
        ],
      },
    ],
  },
  // {
  //   name: "30 ноября 1993 г. - День герба России",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-043.jpg",
  //   url: "den-gerba",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "1 декабря 1853 г. - Синопское сражение",
    shortDesc:
      "Синопское сражение вошло в историю как последнее крупное морское сражение парусных флотов, где проявили свою доблесть, взаимовыручку и талант русские моряки под командованием легендарного Павла Степановича Нахимова. Несмотря на огневую поддержку турецких кораблей наземными орудиями, 1 декабря 1853 года всего за несколько часов османский флот был полностью уничтожен силами русской эскадры. Победа русского флота, укрепление позиций в Черном море предзнаменовало начало агрессии против России, вошедшей в историю как Крымская война. В Севастополе 18 ноября 1898 года в честь победоносного русского адмирала и к 45-летию Синопского сражения был торжественно открыт памятник Нахимову, а на одном из горельефов изображена сцена битвы в Синопской бухте. Подобную сцену запечатлел знаменитый русский художник Иван Константинович Айвазовский в работе «Синопский бой», находящейся в Центральном военно-морском музее имени императора Петра Великого.",
    img: "/assets/imgs/kalendar/image-044.jpg",
    url: "sinopskoe-srajenie",
    fullDesc: ".",
    quizes: [
      {
        name: "Во время какой войны произошло Синопское сражение?",
        variations: [
          {
            name: "Крымская война",
            isCorrect: true,
          },
          { name: "Русско-турецкая война 1787 года" },
          { name: "Русско-турецкая война 1877 года" },
          { name: "Первая мировая война" },
        ],
      },
    ],
  },
  // {
  //   name: "3 декабря 2014 г. - День Неизвестного Солдата",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-045.jpg",
  //   url: "den-neizvestnogo-soldata",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   name: "5 декабря 1941 г. - День начала контрнаступления советских войск в битве под Москвой",
  //   shortDesc: ".",
  //   img: "/assets/imgs/kalendar/image-046.jpg",
  //   url: "den-kontrnastupleniya",
  //   fullDesc: ".",
  //   quizes: [
  //     {
  //       name: "Викторина по Декларации о государственном суверенитете",
  //       variations: [
  //         {
  //           name: "Что утверждала Декларация о государственном суверенитете?",
  //           isCorrect: true,
  //         },
  //         { name: "Независимость от России" },
  //         { name: "Присоединение к другой стране" },
  //         { name: "Продолжение контроля Советского Союза" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "9 декабря - День Героев Отечества",
    shortDesc:
      "Памятная дата 'День Героев Отечества' была установлена Государственной Думой Российской Федерации 26 января 2007 года, продолжив старую традицию почитания героев со времен Российской империи. В пояснительной записке к законопроекту говорилось: 'мы не только отдаем дань памяти героическим предкам, но и чествуем ныне живущих Героев Советского Союза, Героев Российской Федерации, кавалеров ордена Святого Георгия и ордена Славы'. Эта памятная дата символизирует благодарное и уважительное отношение нашего народа к своим героям, вдохновляя граждан на самоотверженное и бескорыстное служение нашему Отечеству.  Ежегодно в Георгиевском зале Кремля проходит почетной прием, на который приглашены герои СССР и России, а также многие другие орденоносцы и почетные гости. По всей стране 9 декабря проходят различные праздничные акции при поддержке патриотических клубов и общественных организаций.",
    img: "/assets/imgs/kalendar/image-047.jpg",
    url: "den-geroyev",
    fullDesc: ".",
    quizes: [
      {
        name: "Назовите дату празднования Дня Героев Отечества",
        variations: [
          {
            name: "9 декабря",
            isCorrect: true,
          },
          { name: "7 октября" },
          { name: "9 мая" },
          { name: "23 февраля" },
        ],
      },
    ],
  },
  {
    name: "12 декабря 1993 г. - День Конституции России",
    shortDesc:
      "Принятие Конституции 1993 года явилось важным шагом в укреплении единства Российского государства. С распадом Союза ССР Конституция РСФСР приобрела новое сущностное свойство. Это была уже не Конституция субъекта Федерации, а Конституция независимого, самостоятельного государства. Сложная расстановка политических сил в составе народных депутатов приводила к значительной затяжке принятия новой Конституции. В связи с внесением большого количества противоречащих друг другу предложений в проект Конституции возникала несогласованность, которая вызывала ожесточенное противостояние и противоборство законодательной и исполнительной властей. Пиком противостояния стали события в октябре 1993 года, разрешившиеся в ходе вооруженного столкновения властей, роспуском Съезда народных депутатов и Верховного Совета. Новая Конституция была принята всенародным голосованием 12 декабря 1993 года и вступила в действие со дня ее опубликования 25 декабря того же года.",
    img: "/assets/imgs/kalendar/image-048.jpg",
    url: "den-konsitutsii",
    fullDesc: ".",
    quizes: [
      {
        name: "Какой государственный праздник отмечается в России 12 декабря?",
        variations: [
          {
            name: "День Конституции России",
            isCorrect: true,
          },
          { name: "День флага России" },
          { name: "День герба России" },
          { name: "День гимна России" },
        ],
      },
    ],
  },
  {
    name: "24 декабря 1790 г. - Взятие крепости Измаил",
    shortDesc:
      "День взятия до ныне неприступной крепости Измаил навсегда вошёл в историю России как день героического подвига русских воинов, их несгибаемой воли и стойкости, а тактический гений Александра Васильевича Суворова стал частью российской военной науки, принеся множество великих побед в будущем. В 2015 году к 225-летию взятия Измаила в селе Павловское Владимирской области был открыт белокаменный памятник. Он располагается на территории «Усадьбы двух генералов», с постоянной экспозицией «Страшись, о рать иноплеменных! России двинулись сыны».",
    img: "/assets/imgs/kalendar/image-049.jpg",
    url: "vzyatie-izmaila",
    fullDesc: ".",
    quizes: [
      {
        name: "Кто руководил взятием крепости Измаил?",
        variations: [
          {
            name: "А. В. Cуворов",
            isCorrect: true,
          },
          { name: "М. И. Кутузов" },
          { name: "П. С. Нахимов" },
          { name: "Кузьма Минин" },
        ],
      },
    ],
  },
];